require('../../modules/es.string.match-all');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'matchAll');
